<template>
  <div>
    <div class="head-box dis-flex">
      <div class="home-page font-bolder" @click="jumpHome">Home Page</div>
      <div class="dis-flex head-content">
        <div :class="{ 'back-color': headType == 1 }" class="flex1 font-bolder">
          <span>Electrical Appliances</span>
        </div>
        <img src="@/assets/images/right.png" />
        <div :class="{ 'back-color': headType == 2 }" class="flex1 font-bolder">
          <span>Solar System Setup</span>
        </div>
        <img src="@/assets/images/right.png" />
        <div :class="{ 'back-color': headType == 3 }" class="flex1 font-bolder">
          <span>Solution Showcase</span>
        </div>
      </div>
      <div
        :class="{ 'back-color': headType == 4 }"
        class="dashboard font-bolder"
      >
        Dashboard
      </div>
    </div>
  </div>
</template>

<script>
import { dealCode } from "@/js/lib/dealCode";
export default {
  props: {
    headType: {
      type: String,
      default: "1"
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    jumpHome() {
      // console.log(this.$route.query.planId);
      let planId = this.$route.query.planId;
      if (planId) {
        localStorage.setItem("planId", planId);
      }
      this.$emit("leaveListen");
      this.$router.push({ name: "Home" });
    }
  }
};
</script>
<style lang="scss" scoped type="text/css">
.head-box {
  height: 9.8vh;
  align-items: center;
  .home-page {
    cursor: pointer;
    width: 250px;
    height: 5.5vh;
    line-height: 5.5vh;
    text-align: center;
    border-radius: 10px;
    background: linear-gradient(0deg, #515152 0%, #6f6f6f 100%);
    // box-shadow: 0px -2px 4px 0px rgba(98, 98, 98, 0.86);
    font-size: 2.2vh;
    font-weight: bold;
    color: #ffffff;
    margin-right: 40px;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: -20px;
      display: block;
      width: 2px;
      height: 100%;
      background-color: #565656;
    }
  }

  .dashboard {
    width: 25%;
    min-width: 368px;
    cursor: default;
    background: #202124;
    font-size: 2vh;
    font-weight: bold;
    color: #5b5d64;
    text-align: center;
    height: 5.5vh;
    line-height: 5.5vh;
    border-radius: 10px;
    flex-shrink: 1;
    margin-left: 40px;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: -20px;
      display: block;
      width: 2px;
      height: 100%;
      background-color: #565656;
    }
  }
  .home-page:hover {
    background: linear-gradient(0deg, #189ebd 0%, #17c0e7 100%);
    box-shadow: 0px -2px 3px 0px rgba(29, 181, 217, 0.74);
  }
  .head-content {
    flex: 1;
    align-items: center;
    > img {
      display: block;
      width: 14px;
      height: 14px;
      margin: 0 30px 0 25px;
    }
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: default;
      // flex: 1;
      background: #202124;
      font-size: 1vmax;
      font-weight: bold;
      color: #5b5d64;
      text-align: center;
      height: 5.5vh;
      border-radius: 10px;
    }
    .back-color {
      color: #aaa;
      background: #202124;
      border: 1px solid #aaa;
      border-radius: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headerTop/HeaderTop.vue